/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a637a9bba565cb7fd2f12308fc284013>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */
export { ConfluenceLogo } from './logo';
export { ConfluenceLogoCS } from './logo-cs';
export { ConfluenceIcon } from './icon';
